var _path, _path2, _g, _circle, _path3, _g2, _g3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlossaryCreate = function SvgGlossaryCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 170 170"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#glossary_create_svg__a)",
    d: "M25.85 38.32h108.3v116.036H41.321c-8.544 0-15.47-6.926-15.47-15.471V38.321Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#glossary_create_svg__b)",
    d: "M25.85 38.322c0-8.545 6.927-15.472 15.471-15.472h92.829v30.943H41.321c-8.544 0-15.47-6.927-15.47-15.471Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glossary_create_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.622 89.621V50.943h23.207V89.62l-11.604-11.603L92.622 89.62Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 29.5,
    r: 15.5,
    fill: "#FFB800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M131.177 28.668a.83.83 0 1 0 0 1.66h3.321a.83.83 0 1 0 0-1.66h-3.321Z",
    clipRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glossary_create_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 29.5,
    r: 15.5,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M126.447 23.17c0-.499.405-.903.904-.903h10.85c.5 0 .905.404.905.904v5.005a3.615 3.615 0 0 1 1.109 5.27l2.462 2.868a.904.904 0 0 1-1.279 1.278l-2.292-2.67v1.811c0 .5-.405.904-.905.904h-10.85a.904.904 0 0 1-.904-.904V23.171Zm10.85 11.755a3.617 3.617 0 0 1-3.133-1.808h-4.1a.904.904 0 0 1 0-1.809h3.617c0-.312.039-.615.114-.904h-3.731a.904.904 0 0 1 0-1.808h4.521c.095 0 .187.014.274.042a3.603 3.603 0 0 1 2.438-.946v-3.617h-9.041v11.754h9.041v-.904Zm-7.233-9.042a.904.904 0 0 0 0 1.808h5.425a.904.904 0 0 0 0-1.808h-5.425Zm7.233 7.234a1.809 1.809 0 1 0 0-3.618 1.809 1.809 0 0 0 0 3.618Z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glossary_create_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#glossary_create_svg__f)",
    d: "M23 130c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.895 101.553a1 1 0 0 0-1.79 0l-2.99 5.982-.019.037-.99 1.981a1 1 0 1 0 1.789.894l.723-1.447h4.764l.714 1.428a1 1 0 0 0 .926.572h.905a7.02 7.02 0 0 0 1.548 4.265c-.706.394-1.556.66-2.553.738a1 1 0 0 0 .156 1.994c1.562-.123 2.873-.607 3.922-1.322 1.05.715 2.36 1.199 3.922 1.322a1 1 0 0 0 .156-1.994c-.997-.078-1.847-.344-2.552-.738A7.021 7.021 0 0 0 30.073 111H31a1 1 0 0 0 0-2h-3v-1a1 1 0 0 0-2 0v1h-2.382l-.714-1.428a.637.637 0 0 0-.018-.037l-2.991-5.982ZM28.073 111h-2.146A4.991 4.991 0 0 0 27 113.97a4.991 4.991 0 0 0 1.073-2.97Zm-7.69-4L19 104.236 17.618 107h2.764ZM19 111a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm7-6a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1h-2a1 1 0 0 0 0 2h1v1Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "glossary_create_svg__a",
    x1: 80,
    x2: 80,
    y1: 38.321,
    y2: 154.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82BBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5689C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glossary_create_svg__b",
    x1: 29,
    x2: 134,
    y1: 38,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5183BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6199D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glossary_create_svg__f",
    x1: 23,
    x2: 23,
    y1: 90,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0E7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DD1B3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glossary_create_svg__c",
    width: 31.207,
    height: 46.679,
    x: 88.622,
    y: 47.943,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.341176 0 0 0 0 0.541176 0 0 0 0 0.764706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_789_38710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_789_38710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glossary_create_svg__d",
    width: 71,
    height: 71,
    x: 99,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_789_38710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_789_38710",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glossary_create_svg__e",
    width: 50.074,
    height: 50.074,
    x: 0.481,
    y: 87.481,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.519,
    dy: 2.519
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.519
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0846528 0 0 0 0 0.150363 0 0 0 0 0.383333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_789_38710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_789_38710",
    result: "shape"
  })))));
};
export default SvgGlossaryCreate;